const buttonTypeVariants = {
    primary: {},
    secondary: {},
    tertiary: {},
    primaryShop: {},
    critical: {},
    radialPrimary: {},
    radialSecondary: {},
    radialTertiary: {}
};
const buttonTypes = Object.keys(buttonTypeVariants);
const buttonSizeVariants = {
    sm: {
        buttonSlot: 'rounded-action-sm',
        wrapperSlot: 'min-h-8 px-2 py-1 gap-x-1',
        textSlot: 'text-action2'
    },
    md: {
        buttonSlot: 'rounded-action-md',
        wrapperSlot: 'min-h-10 px-3 py-2 gap-x-1',
        textSlot: 'text-action2'
    },
    lg: {
        buttonSlot: 'rounded-action-xl',
        wrapperSlot: 'px-4 py-3 gap-x-1.5',
        textSlot: 'text-action1'
    },
    xl: {
        buttonSlot: 'rounded-action-xl',
        wrapperSlot: 'p-4 gap-x-1.5',
        textSlot: 'text-action1'
    }
};
const buttonSizes = Object.keys(buttonSizeVariants);
const buttonEmphasisVariants = {
    regular: '',
    medium: '',
    bold: ''
};
const buttonEmphases = Object.keys(buttonEmphasisVariants);
const buttonSlots = {
    buttonSlot: 'align-center antialiased align-middle focus-visible:ring-actionSecondary-12 cursor-pointer touch-manipulation transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
    wrapperSlot: 'flex flex-row items-center justify-center rounded-full',
    textSlot: 'px-1 font-bold',
    iconSlot: 'transition'
};
const buttonFullWidthVariants = {
    true: {
        buttonSlot: 'w-full'
    }
};
const buttonShadowVariants = {
    true: {
        buttonSlot: 'shadow-md hover:shadow-xl'
    }
};
const buttonShadows = Object.keys(buttonShadowVariants);
const buttonDropShadowVariants = {
    true: {
        buttonSlot: 'drop-shadow-md hover:drop-shadow-xl'
    }
};
const buttonDisabledVariants = {
    true: {
        buttonSlot: 'cursor-not-allowed shadow-none'
    }
};
const compoundVariants = {
    primary: [
        {
            emphasis: 'regular',
            type: 'primary',
            class: {
                buttonSlot: 'bg-actionPrimary-8 hover:bg-actionPrimary-9 text-actionPrimary-3 hover:text-actionPrimary-4'
            }
        },
        {
            emphasis: 'medium',
            type: 'primary',
            class: {
                buttonSlot: 'bg-actionPrimary-8 hover:bg-actionPrimary-9 text-actionPrimary-3 hover:text-actionPrimary-4'
            }
        },
        {
            emphasis: 'bold',
            type: 'primary',
            class: {
                buttonSlot: 'bg-actionPrimary-3 hover:bg-actionPrimary-4 focus-visible:ring-actionPrimary-1 focus-visible:ring-offset-actionPrimary-12 text-actionPrimary-8 hover:text-actionPrimary-9'
            }
        }
    ],
    secondary: [
        {
            emphasis: 'regular',
            type: 'secondary',
            class: {
                buttonSlot: 'bg-actionSecondary-8 hover:bg-actionSecondary-9 text-actionSecondary-3 hover:text-actionSecondary-4'
            }
        },
        {
            emphasis: 'medium',
            type: 'secondary',
            class: {
                buttonSlot: 'bg-actionSecondary-1/80 hover:bg-actionSecondary-1 text-actionSecondary-3 hover:text-actionSecondary-4'
            }
        },
        {
            emphasis: 'bold',
            type: 'secondary',
            class: {
                buttonSlot: 'bg-actionSecondary-8/20 hover:bg-actionSecondary-9/40 text-actionSecondary-1 hover:text-actionSecondary-2'
            }
        }
    ],
    tertiary: [
        {
            emphasis: 'regular',
            type: 'tertiary',
            class: {
                buttonSlot: 'hover:bg-actionSecondary-9 text-actionSecondary-3 hover:text-actionSecondary-4'
            }
        },
        {
            emphasis: 'medium',
            type: 'tertiary',
            class: {
                buttonSlot: 'hover:bg-actionSecondary-1/80 text-actionSecondary-3 hover:text-actionSecondary-4'
            }
        },
        {
            emphasis: 'bold',
            type: 'tertiary',
            class: {
                buttonSlot: 'ring-actionSecondary-12 hover:bg-actionSecondary-8/20 text-actionSecondary-1 hover:text-actionSecondary-2'
            }
        }
    ],
    radialPrimary: [
        {
            type: 'radialPrimary',
            disabled: false,
            class: {
                wrapperSlot: 'isolate inset-shadow-radialPrimary relative overflow-hidden before:absolute before:inset-0 before:bg-radialPrimary after:absolute after:inset-0 after:bg-radialPrimaryActive after:opacity-0 before:transition-opacity after:transition-opacity before:duration-300 after:duration-300 before:ease-in-out after:ease-in-out hover:after:opacity-100',
                buttonSlot: 'active:scale-90 bg-transparent text-penny-1',
                iconSlot: 'relative z-1',
                textSlot: 'relative z-1'
            }
        },
        {
            type: 'radialPrimary',
            shadow: true,
            class: {
                buttonSlot: 'shadow-penny-sm hover:shadow-penny-md'
            }
        }
    ],
    radialSecondary: [
        {
            type: 'radialSecondary',
            disabled: false,
            class: {
                wrapperSlot: 'isolate inset-shadow-radialPrimary relative overflow-hidden before:absolute before:inset-0 before:bg-radialSecondary after:absolute after:inset-0 after:bg-radialSecondaryActive after:opacity-0 before:transition-opacity after:transition-opacity before:duration-300 after:duration-300 before:ease-in-out after:ease-in-out hover:after:opacity-100',
                buttonSlot: 'active:scale-90 bg-transparent text-penny-13',
                iconSlot: 'relative z-1 transition-none',
                textSlot: 'relative z-1'
            }
        },
        {
            type: 'radialSecondary',
            shadow: true,
            class: {
                buttonSlot: 'shadow-penny-sm hover:shadow-penny-md'
            }
        }
    ],
    radialTertiary: [
        {
            type: 'radialTertiary',
            disabled: false,
            class: {
                wrapperSlot: 'isolate inset-shadow-radialPrimary relative overflow-hidden before:absolute before:inset-0 before:bg-radialTertiary after:absolute after:inset-0 after:bg-radialTertiaryActive after:opacity-0 before:transition-opacity after:transition-opacity before:duration-300 after:duration-300 before:ease-in-out after:ease-in-out hover:after:opacity-100',
                buttonSlot: 'active:scale-90 bg-transparent text-penny-13 hover:text-penny-1',
                iconSlot: 'relative z-1 transition-none',
                textSlot: 'relative z-1'
            }
        },
        {
            type: 'radialTertiary',
            emphasis: 'bold',
            disabled: false,
            class: {
                wrapperSlot: 'isolate before:bg-glassRadial',
                buttonSlot: 'text-penny-1',
                iconSlot: 'relative z-1 transition-none'
            }
        },
        {
            type: 'radialTertiary',
            shadow: true,
            class: {
                buttonSlot: 'shadow-penny-sm hover:shadow-penny-md'
            }
        }
    ],
    primaryShop: [
        {
            emphasis: 'regular',
            type: 'primaryShop',
            class: {
                buttonSlot: 'bg-actionShop-8 hover:bg-actionShop-9 text-actionShop-3 hover:text-actionShop-4'
            }
        },
        {
            emphasis: 'medium',
            type: 'primaryShop',
            class: {
                buttonSlot: 'bg-actionShop-8 hover:bg-actionShop-9 text-actionShop-3 hover:text-actionShop-4'
            }
        },
        {
            emphasis: 'bold',
            type: 'primaryShop',
            class: {
                buttonSlot: 'bg-actionShop-3 hover:bg-actionShop-4 text-actionShop-8 hover:text-actionShop-9 focus-visible:ring-actionPrimary-1 focus-visible:ring-offset-actionPrimary-12'
            }
        }
    ],
    critical: [
        {
            emphasis: 'regular',
            type: 'critical',
            class: {
                buttonSlot: 'bg-actionCritical-8 hover:bg-actionCritical-9 text-actionCritical-3 hover:text-actionCritical-4'
            }
        },
        {
            emphasis: 'medium',
            type: 'critical',
            class: {
                buttonSlot: 'bg-actionCritical-8 hover:bg-actionCritical-9 text-actionCritical-3 hover:text-actionCritical-4'
            }
        },
        {
            emphasis: 'bold',
            type: 'critical',
            class: {
                buttonSlot: 'bg-actionCritical-3 hover:bg-actionCritical-4 text-actionCritical-8 hover:text-actionCritical-9 focus-visible:ring-actionPrimary-1 focus-visible:ring-offset-actionPrimary-12'
            }
        }
    ],
    disabled: [
        {
            emphasis: 'regular',
            disabled: true,
            class: {
                buttonSlot: 'bg-actionPrimary-2 hover:bg-actionPrimary-2 text-actionPrimary-6 hover:text-actionPrimary-6',
                wrapperSlot: 'before:hidden after:hidden pointer-events-none'
            }
        },
        {
            emphasis: 'medium',
            disabled: true,
            class: {
                buttonSlot: 'bg-actionPrimary-1/60 hover:bg-actionPrimary-1/60 text-actionPrimary-6 hover:text-actionPrimary-6',
                wrapperSlot: 'before:hidden after:hidden pointer-events-none'
            }
        },
        {
            emphasis: 'bold',
            disabled: true,
            class: {
                buttonSlot: 'bg-actionPrimary-1/20 hover:bg-actionPrimary-1/20 text-actionPrimary-1/40 hover:text-actionPrimary-1/40',
                wrapperSlot: 'before:hidden after:hidden pointer-events-none'
            }
        }
    ]
};
const buttonCompoundVariants = [
    ...compoundVariants.primary,
    ...compoundVariants.secondary,
    ...compoundVariants.tertiary,
    ...compoundVariants.primaryShop,
    ...compoundVariants.critical,
    ...compoundVariants.radialPrimary,
    ...compoundVariants.radialSecondary,
    ...compoundVariants.radialTertiary,
    ...compoundVariants.disabled,
    {
        shadow: true,
        disabled: true,
        class: {
            buttonSlot: 'shadow-none hover:shadow-none'
        }
    }
];
const buttonDefaultVariants = {
    emphasis: 'regular',
    type: 'secondary',
    size: 'md'
};
export { buttonCompoundVariants, buttonDefaultVariants, buttonDisabledVariants, buttonDropShadowVariants, buttonEmphases, buttonEmphasisVariants, buttonFullWidthVariants, buttonShadowVariants, buttonShadows, buttonSizeVariants, buttonSizes, buttonSlots, buttonTypeVariants, buttonTypes };
